import $ from 'jquery'

// eslint-disable-next-line no-undef
const object = ongmObject

const input = $('.service-ajax-search')
const results = input.parent().find('.search-form__results')

input
  .autocomplete({
    minLength: 3,
    appendTo: results,
    source: function (request, response) {
      $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        dataType: 'JSON',
        data: {
          _ajax_nonce: object.nonce,
          action: 'ongm_get_posts',
          keyword: request.term,
          postType: 'service',
        },
        success: function (res) {
          response(res.data.data)
        },
      })
    },
    search: function (event) {
      $(event.target).parents('.search-form').addClass('search-form--searching')
    },
    open: function (event) {
      $(event.target).parents('.search-form').addClass('search-form--active')
      $(event.target).addClass('autocomplete-active')
    },
    close: function (event) {
      $(event.target).parents('.search-form').removeClass('search-form--active')
      $(event.target).removeClass('autocomplete-active')
    },
    response: function (event) {
      $(event.target)
        .parents('.search-form')
        .removeClass('search-form--searching')
    },
    create: function () {
      $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
        return $('<li>')
          .append(
            `<a href="${item.url}" data-id="${item.id}" class="ajax-post${
              !item.success ? ' ajax-post--error' : ''
            }">${
              item.thumbnail
                ? `<img src="${item.thumbnail}" alt="${item.name}">`
                : ''
            }<div><span class="ajax-post__title">${
              item.title
            }</span><span class="ajax-post__discover">${
              object.readMore
            }</span></div></a>`
          )
          .appendTo(ul)
      }
    },
  })
  .focus(function () {
    $(this).data('uiAutocomplete').search($(this).val())
  })
